import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';
import { NgsPlacementFormComponent } from './ngs-placement-form/ngs-placement-form.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-ngs-placement-test',
  templateUrl: './ngs-placement-test.component.html',
  styleUrls: ['./ngs-placement-test.component.scss']
})
export class NgsPlacementTestComponent implements OnInit {
  tabs = TESTING_CENTER.GENERAL_TESTING;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: PlacementTest,
    public ps: PrintService,
    private dialog:MatDialog,
  ) { }

  ngOnInit() {
    this.store.fetchClass()
  }

  
  create(item: any) {
    let dialogRef = this.dialog.open(NgsPlacementFormComponent, {
      data: {
        ITEM: item,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {});
  }
  
  }
